export * from './lib/light-carousel/light-carousel.component';
